"use client";

import { useRouter } from "next/navigation";
import { Button as WowButton } from "@/components/ui/warcraftcn/button";
import { useWowMode } from "@/components/wow/wow-mode";

/** WoW game-menu style home screen shown when the easter egg is active. */
export function WowGameMenu() {
  const router = useRouter();
  const { setActive } = useWowMode();

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-10 px-6">
      <header className="flex flex-col items-center gap-2 text-center">
        <h1 className="wow-gold-text text-5xl sm:text-6xl">RESURRECTION</h1>
        <p className="fantasy mt-2 max-w-md text-sm text-muted-foreground">
          Search Logics cases and preview the full Salesforce object graph
          before importing.
        </p>
      </header>

      <nav className="flex w-full max-w-70 flex-col gap-3">
        <WowButton
          variant="frame"
          className="h-16 text-base"
          onClick={() => router.push("/resurrect")}
        >
          Open migration preview
        </WowButton>
        <WowButton onClick={() => setActive(false)}>
          Exit WoW interface
        </WowButton>
      </nav>
    </main>
  );
}
